import { List, Map } from 'immutable';

import { isObject } from './isObject';
import { reduce } from './iterable/reduce';

import { EMPTY, SEPARATOR } from '../constants';

export function toLowerCase(string) {
  return typeof string?.toLowerCase === 'function' ? string.toLowerCase() : string;
}

export function toUpperCase(string) {
  return typeof string?.toUpperCase === 'function' ? string.toUpperCase() : string;
}

export function toString(value) {
  return typeof value?.toString === 'function' ? value.toString() : value;
}

export function trim(value) {
  return typeof value?.trim === 'function' ? value.trim() : value;
}

export function trimSpaces(value) {
  return trim(value.replace(/\s+/g, SEPARATOR.SPACE));
}

export function capitalize(string, everyWord = false) {
  const result = String(string);
  const pattern = everyWord
    ? RegExp('(^\\w|\\s+\\w)', 'g')
    : RegExp('(^\\w|\\.\\s+\\w)', 'g');

  return result
    ? result.replace(pattern, toUpperCase)
    : string;
}

export function escapeRegex(string) {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function toCamelCase(key) {
  function callback(match, index) {
    return index === 0
      ? toLowerCase(match)
      : capitalize(toLowerCase(match.substring(1)));
  }

  const value = String(key);

  return value
    ? value.replace(/[-_][a-z0-9]+/ig, callback)
    : key;
}

export function toKebabCase(string) {
  if (!string) return '';

  return string
    .replace(/[^\w]+|_+/g, SEPARATOR.HYPHEN)
    .replace(/^-+|-+(?=-)|-+$/gi, '')
    .toLowerCase();
}

export function toSnakeCase(string) {
  if (!string) return '';

  return string
    .replace(/[^\w]/g, SEPARATOR.UNDERSCORE)
    .replace(/^_+|_+(?=_)|_+$/gi, '')
    .toLowerCase();
}

export function keysToCamelCase({ data, formatters = {}, toImmutable }) {
  function reduceArray(result, value) {
    const formattedValue = keysToCamelCase({ data: value, toImmutable });

    if (toImmutable) {
      return result.push(formattedValue);
    }

    result.push(formattedValue);

    return result;
  }

  function reduceObject(result, value, key) {
    const formattedValue = typeof formatters[key] === 'function'
      ? formatters[key](value)
      : keysToCamelCase({ data: value, toImmutable });

    if (toImmutable) {
      return result.set(toCamelCase(key), formattedValue);
    }

    result[toCamelCase(key)] = formattedValue;

    return result;
  }

  if (List.isList(data)) {
    return data.reduce(reduceArray, toImmutable ? EMPTY.LIST : []);
  }

  if (Map.isMap(data)) {
    return data.reduce(reduceObject, toImmutable ? EMPTY.MAP : {});
  }

  if (Array.isArray(data)) {
    return data.reduce(reduceArray, toImmutable ? EMPTY.LIST : []);
  }

  if (isObject(data)) {
    return reduce(data, toImmutable ? EMPTY.MAP : {}, reduceObject);
  }

  return data;

}

export function trimLeadingSpace(value) {
  return value.replace(/^\s+/g, '');
}

export function isEmptyOrNull(string) {
  return !string || (typeof string === 'string' && string.trim() === 'null');
}
